import React from 'react';
import { Link } from 'react-router-dom';
import { footerNav } from '../../data/navigation';
import { store } from '../../data/store';
import { NewsletterForm } from '../ui/NewsletterForm';
export function Footer() {
  return <footer className="mt-24 bg-ink text-paper" data-id="element-370" data-mp="akukgsjjmuil">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-16 md:px-8 md:pt-20" data-id="element-371" data-mp="5nchrjw4dbj1">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-372" data-mp="5pf49ty2cmj0">
          <div className="lg:col-span-5" data-id="element-373" data-mp="p14ez6m8iw2">
            <p className="font-display text-4xl leading-[1.05] md:text-5xl" data-id="element-374" data-mp="pu79p2geo8x">
              Revenez souvent.
              <br data-id="element-375" data-mp="3n3k9u6dm4nqe" />
              <em className="text-[#E9A88F]" data-id="element-376" data-mp="3n32i9n1waxot">La boutique ne sera jamais tout à fait la même.</em>
            </p>
            <p className="mt-6 max-w-sm text-sm text-paper/70" data-id="element-377" data-mp="3j2s1dfckemv6">
              Une lettre à chaque arrivée de créateur, et un rappel quelques jours avant les départs.
            </p>
            <div className="mt-5 max-w-sm" data-id="element-378" data-mp="3939heywnn134">
              <NewsletterForm tone="dark" data-id="element-379" data-mp="394b4y2uuxg1q" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7 lg:pl-12" data-id="element-380" data-mp="2kc1x8pkf5lxz">
            {footerNav.map(col => <div key={col.title} data-id="element-381" data-mp="2p54j0biyfr3m">
                <p className="text-xs font-medium text-paper/60" data-id="element-382" data-mp="2bcolfq8tola3">{col.title}</p>
                <ul className="mt-4 space-y-2.5" data-id="element-383" data-mp="2balkwca1n9r4">
                  {col.links.map(l => <li key={l.label} data-id="element-384" data-mp="2g9exm2hiawq8">
                      <Link to={l.to} className="text-sm text-paper/90 transition-colors duration-150 hover:text-paper hover:underline hover:underline-offset-4" data-id="element-385" data-mp="340u7qhfiyic1">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
        <div className="mt-16 grid gap-6 border-t border-paper/15 pt-8 text-sm text-paper/70 md:grid-cols-3" data-id="element-386" data-mp="2z43sfwbjnqro">
          <address className="not-italic" data-id="element-387" data-mp="1iq3w0vbwqj96">
            <p className="text-paper" data-id="element-388" data-mp="1nn3yyxdgn5w2">{store.name}</p>
            <p data-id="element-389" data-mp="1nkhk0co8po3t">
              {store.address}, {store.city}
            </p>
          </address>
          <div data-id="element-390" data-mp="13mu4mf2pbl7u">
            {store.hours.map(h => <p key={h.days} data-id="element-391" data-mp="zk76jwfft427">
                {h.days} · {h.time}
              </p>)}
          </div>
          <div className="md:text-right" data-id="element-392" data-mp="uqut8ig7kjor">
            <p data-id="element-393" data-mp="ptchkkat3qd2">
              <a href={`mailto:${store.email}`} className="hover:text-paper" data-id="element-394" data-mp="ptup4d2x5r0a">
                {store.email}
              </a>
            </p>
            <p className="mt-1" data-id="element-395" data-mp="kvt4hnpuhjmp">© 2026 · Paiement sécurisé · Fait main, vendu en main propre</p>
          </div>
        </div>
      </div>
    </footer>;
}